export const environment = {
  production: true,
  apiUrl: 'https://test-api.couponer.app'
};
